/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Header_InInputs */



/**
* | output |
* | --- |
* | "IN" |
*
* @param {Ccsl_Export_Header_InInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_header_in = /** @type {((inputs?: Ccsl_Export_Header_InInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Header_InInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("IN")
	if (locale === "de") return /** @type {LocalizedString} */ ("IN")
	if (locale === "it") return /** @type {LocalizedString} */ ("IN")
	if (locale === "ru") return /** @type {LocalizedString} */ ("В")
	if (locale === "es") return /** @type {LocalizedString} */ ("EN")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("在")
	if (locale === "ja") return /** @type {LocalizedString} */ ("で")
	if (locale === "hi") return /** @type {LocalizedString} */ ("में")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("EM")
	return /** @type {LocalizedString} */ ("IN")
});